import { useBatch } from "@/context/BatchContext";

export default function useActiveBatch() {
  return useBatch().batch;
}
